import { calmTokens as t } from '../shared/tokens';

export default function CalmNavPill({ icon, label, active = false, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 14px',
        background: active ? t.surface2 : 'transparent',
        color: active ? t.text : t.textDim,
        border: `1px solid ${active ? t.borderS : 'transparent'}`,
        borderRadius: 999,
        fontSize: 13,
        fontWeight: active ? 500 : 400,
        fontFamily: t.fontUi,
        letterSpacing: -0.1,
        cursor: 'pointer',
        transition: 'all .2s',
      }}
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}
